var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseView',[_c('PersonStep',{attrs:{"close":"","fields":['selfie', 'name'],"is-dependent":"","my-profile-adapter":_vm.myProfileAdapter,"title":_vm.$t('title')},on:{"cancel":_vm.back,"ok":_vm.back}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }